import { getLanguage } from 'data/locale'

import loginBg from '../../assets/login-bg.jpg'
import imagineLogo from '../../assets/imagine-logo.svg'
import logoWhite from '../../assets/logo-white.svg'
import logoWhiteFr from '../../assets/logo-white-fr.svg'

const LoginSidePanel = () => {
  const { language, t } = getLanguage()

  const logoImage = language === 'fr' ? logoWhiteFr : logoWhite

  return (
    <div className="Login-sidePanel" style={{ backgroundImage: `url(${loginBg})` }}>
      <img src={logoImage} alt="logo" />
      <div>
        <h2>{t.global.loginHeaderText}</h2>
        <hr />
        <p>{t.global.loginText}</p>
      </div>
      <img src={imagineLogo} alt="Imagine Canada" className="Login-logo" />
    </div>
  )
}

export default LoginSidePanel
